/**
 * Nombres de los cachés runtime de Workbox. Compartidos entre vite.config.ts
 * (donde se configuran las reglas) y cache.ts (purga al cerrar sesión).
 */

export const T123_API_CACHE = "t123-api-v1";
export const T123_UPLOADS_CACHE = "t123-uploads-v1";
